module.exports = __webpack_public_path__ + "static/img/2.7a4e29e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/servicios/2.png
// module id = wkwd
// module chunks = 0